export const EthnicGroups = [
  {
    value: 0,
    name: 'Hispanic Or Latino',
  },
  {
    value: 1,
    name: 'Non Hispanic Or Latino',
  },
  {
    value: 2,
    name: 'Unknown',
  },
];
